import { getText, appendText } from '../../../assets/js/text-renderer';

import './pricing-collector.scss';
import '../../shared/pricing-card.scss';

//! Hay un problema aquí: Cuando se importa el web-component, este ejecuta su método connectedCallback, por cada instancia del componente en el DOM. De está manera, después del pre-render, se vuelve a ejecutar el connectedCallback, resolviendo, no solo comportamientos inesperados. Si no también, la duplicación de elementos en el DOM. Se requiere buscar una solución para este problema.
import '../../shared/faqs/faqs';

export const loadText = async () => {
  const data = await getText('platform/intelek-collector/intelek-collector-pricing');
  const content = data.stories[0].content;
  setFaqsContent(content);
};

function setFaqsContent(content) {
  const faqsContainer = document.getElementById('faqs');
  const faqsEl = document.createElement('custom-faqs');

  content.FAQS.forEach((faq) => {
    const faqElement = document.createElement('li');
    faqElement.setAttribute('title', faq.title);
    faqElement.setAttribute('content', faq.text);
    faqsEl.appendChild(faqElement);
  });

  faqsContainer.appendChild(faqsEl);
  appendText(content.any_more_questions, 'any_more_questions');
}
